import { Vehicle } from './vehicles';

export interface PersonBonus {
	bonus: Bonus[];
}

export interface Bonus {
	id: string;
	imageUrl: string;
	imageUrlLayer: string;
	priority: number;
	isLayer: boolean;
	type: string;
	campaign?: BonusCampaign;
	imageVerticalUrl: string;
	status: BonusStatus;
	dateValidity: number | Date | string;
	dateExpiration: number | Date | null | string;
	dateEnjoyed?: number | Date | null | string;
	category?: Category;
	title: string;
	titleLayer: string;
	description: string;
	mode: string;
	legalText: string;
	validityText: string;
	cta: Cta;
	frame?: string;
}

export enum BonusCampaign {
	'ENTREGA_IDEAL' = '701QF00000oUwrSYAS',
	'OneToOne_Polo' = '701QF00000yUhK9YAK',
	'OneToOne_ID' = '701QF00000xc39NYAQ',
	'OneToOne_ID_Flotas' = '701Tr00000x9YdBIAU',
	'IDWeChargePostPedido' = '701QF00001RQU42YAH',
}

export enum FeatureAppStepCitaMode {
	'VENTA' = 'featureAppCitaVentaId',
	'POSVENTA' = 'featureAppCitaPosventaId',
}

export enum BonusStatus {
	'EXPIRED' = 'EXPIRED',
	'ENJOYED' = 'ENJOYED',
	'TO_ENJOY' = 'TO_ENJOY',
	'TO_ENJOY_SOON' = 'TO_ENJOY_SOON',
	'NO_EXPIRATION' = 'NO_EXPIRATION',
	'BBO_TO_REDEEM' = 'BBO_TO_REDEEM',
	'BBO_TO_REDEEM_SOON' = 'BBO_TO_REDEEM_SOON',
	'BBO_REDEEMED' = 'BBO_REDEEMED',
	'BBO_REDEEMED_SOON' = 'BBO_REDEEMED_SOON',
}

export enum BonusTypeEnum {
	'PERSON' = 'PERSON',
	'CAR' = 'CAR',
	'ENJOYED' = 'ENJOYED',
}

export enum CarouselModeEnum {
	'PERSON' = 'PERSON',
	'CAR' = 'CAR',
	'ENJOYED' = 'ENJOYED',
}

export interface Category {
	id: number;
	name: string;
}

export interface CarBonus extends Vehicle {
	personVehicleRelation?: boolean;
	salesGroup: string;
	type: string;
}

export enum BonusAppMode {
	'GARAGE' = 'GARAGE',
	'DETAIL' = 'DETAIL',
}

export interface BonusFilter {
	vin: string;
}

export interface Cta {
	text: string;
	bonusPageId: string;
}
